import { Pipe, PipeTransform } from '@angular/core';
import { formatDuration, intervalToDuration } from 'date-fns';
import { it } from 'date-fns/locale';


@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  /**
   * Formats a duration in seconds. `'long'` (default) yields the verbose,
   * localized form ("4 minuti, 32 secondi"); `'compact'` yields a terse
   * "4m 32s" (with `h`/`d` for larger spans) that fits table cells and tooltips.
   */
  transform(seconds: number, format: 'long' | 'compact' = 'long'): string {
    const duration = this.secondsToDuration(seconds);
    if (format === 'compact') {
      return this.formatCompact(duration);
    }
    return formatDuration(duration, {delimiter: ', ', locale: it});
  }

  private formatCompact(duration: ReturnType<DurationPipe['secondsToDuration']>): string {
    const parts: string[] = [];
    if (duration.days) parts.push(`${duration.days}g`);
    if (duration.hours) parts.push(`${duration.hours}h`);
    if (duration.minutes) parts.push(`${duration.minutes}m`);
    if (duration.seconds) parts.push(`${duration.seconds}s`);
    return parts.length ? parts.join(' ') : '0s';
  }

  secondsToDuration(seconds: number) {
    return intervalToDuration({
      start: new Date(0),
      end: new Date(seconds * 1000),
    });
  }

}
